<template>
  <section class="about padding sectionScroll" id="sectionScroll2">
    <div class="container">
      <div class="row">
        <div class="col-6 animation a-translateY a-tr-3">
          <div class="col-6__body">
            <h2 v-if="HEADER_LANG === 'en'">About us</h2>
            <h2 v-if="HEADER_LANG === 'ru'">О нас</h2>
            <p v-if="HEADER_LANG === 'en'">For nearly twenty-five years, SolarBox has developed, implemented and financed sustainable projects that recapture and reinvest otherwise lost resources.</p>
            <p v-if="HEADER_LANG === 'ru'">На протяжении почти двадцати пяти лет SolarBox разрабатывает, внедряет и финансирует проекты, которые возвращают потерянные ресурсы.</p>
          </div>
        </div>
        <div class="col-6 animation a-translateX">
          <picture>
            <source srcset="../../public/static/images/home/2.webp">
            <img src="../../public/static/images/home/2.jpg" alt="">
          </picture>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'SectionAbout',
  components: {},
  methods: {},
  computed: {
    ...mapGetters([
      'HEADER_LANG',
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
// Const
$cRed: #EF3527;
$cBlack: #252525;
$cYellow: #FFA630;
$cWhite: #FFFFFF;
$cGrey: rgba(55, 57, 46, .5);

//
.about {
  background-color: $cBlack;
  .row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    .col-6 {
      flex: 0 0 50%;
      max-width: 50%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &:last-child {
        position: relative;
        &:after {
          position: absolute;
          content: '';
          width: 80%;
          height: 80%;
          top: 40px;
          left: 80px;
          border: 10px solid $cYellow;
          box-sizing: border-box;
          transform: rotate(45deg);
        }
      }
      img {
        width: 100%;
        max-height: 525px;
        height: auto;
        object-fit: cover;
        object-position: center;
        z-index: 2;
        position: relative;
      }
      &__body {
        color: $cWhite;
        position: relative;
        width: 100%;
        height: 100%;
        p, h2 {
          z-index: 2;
          position: relative;
        }
        &:after {
          position: absolute;
          content: '';
          width: 150%;
          height: 150%;
          top: -30px;
          left: -30px;
          background-color: $cRed;
          z-index: 1;
        }
      }
      @media (max-width: 997.98px) {
        flex: 0 0 100%;
        max-width: 100%;
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
